import { stringToUtf8a, u8aToBase64 } from '../helpers';
export class QrCodeService {
    config;
    protocolVersion;
    static $inject = ['CONFIG', 'PROTOCOL_VERSION'];
    constructor(CONFIG, PROTOCOL_VERSION) {
        this.config = CONFIG;
        this.protocolVersion = PROTOCOL_VERSION;
    }
    buildQrCodePayload(initiatorKey, authToken, serverKey, host, port, persistent) {
        const saltyRtcHostBytes = stringToUtf8a(host);
        const buf = new ArrayBuffer(2 + 1 + 32 + 32 + 32 + 2 + saltyRtcHostBytes.byteLength);
        let options = 0;
        options |= (this.config.SELF_HOSTED === true ? 1 : 0) << 0;
        options |= (persistent ? 1 : 0) << 1;
        const dataView = new DataView(buf);
        dataView.setUint16(0, this.protocolVersion);
        dataView.setUint8(2, options);
        const u8Array = new Uint8Array(buf);
        u8Array.set(initiatorKey, 3);
        u8Array.set(authToken, 35);
        if (serverKey === null) {
            u8Array.set(new Uint8Array(32), 67);
        }
        else {
            u8Array.set(serverKey, 67);
        }
        dataView.setUint16(99, port);
        u8Array.set(saltyRtcHostBytes, 101);
        return u8aToBase64(new Uint8Array(buf));
    }
}
